/*
===============================================================================
    File        =   ikimy-website-app/src/pages/Recruiter/MobileRecruiter.js
    Client      =   Rhealize
    Project     =   Ikimy Platform
    Purpose     =   Landing page for the Mobile Recruiter
                    
===============================================================================
    Revision History
        -----------------------------------------------------------------------
        Version Date        Author              Comments
        -----------------------------------------------------------------------
        1.0     2025.03.12  Daniel Rashidian    Initial Creation
        -----------------------------------------------------------------------
===============================================================================
*/

import { HeroRecruiterMobile, EveryoneAgreesMobile, SayGoodByeMobile, SayHelloMobile, NoCrystalBallMobile, TruthFromMobile } from "../../ui-components";
import { useMemo } from "react";
import RecruiterImageHero1 from "../../assets/images/home/RecruiterImageHero1.png"
import RecruiterImageHero2 from "../../assets/images/home/RecruiterImageHero2.png"
import SayGoodbyeImage from "../../assets/images/home/SayGoodByeImage.png"
import SayGoodbyeImage2 from "../../assets/images/home/SayGoodByeImage2.png"
import SayGoodbyeImage3 from "../../assets/images/home/SayGoodByeImage3.png"
import NoCrystalBallImage from "../../assets/images/home/NoCrystalBallImage.png"
import NoCrystalBallImage2Mobile from "../../assets/images/home/NoCrystalBallImage2Mobile.png"
import PartnerWithUsImageMobile from "../../assets/images/home/PartnerWithUsImageMobile.png"

import { Image, Flex, Text } from "@aws-amplify/ui-react";

const RECRUITER_APP = process.env.REACT_APP_RECRUITER_APP;
const RHEALIZE_WEBSITE = process.env.REACT_APP_RHEALIZE_WEBSITE;

const MobileRecruiter = ({

}) => {

    const heroRecruiterMobileOverrides = useMemo(() => {
        return {
            HeroRecruiterMobile: {
                height: "100%",
                width: "100%",
                direction: "row",
                wrap: "wrap"
            },

            "image 2": {
                src: RecruiterImageHero1,
                objectFit: "contain",
                order: "1",
                width: "50%",
                shrink: "1",
                grow: "1",
                basis: "50%",
                height: "100%"

            },

            HeroHeader: {
                order: "3",
                width: "100%"
            },

            "Jobs Made Simple.": {
                height: "unset",
                shrink: "1"
            },
            "Uniting Employers With Top Candidates\u00A0": {
                shrink: "1"
            },
            Button: {
                style: {
                    cursor: "pointer"
                },
                onClick: (event) => {
                    window.open(`${RECRUITER_APP}`, "_blank");
                }
            },
            "image 3": {
                src: RecruiterImageHero2,
                objectFit: "contain",
                order: "2",
                width: "50%",
                shrink: "1",
                grow: "1",
                basis: "50%",
                height: "100%"
            },

        }
    }, []);

    const everyoneAgreesMobileOverrides = useMemo(() => {
        return {
            EveryoneAgreesMobile: {
                width: "100%",
                height: "100%",
                padding: "20px"

            },
            "Group 1160463944": {
                width: "100%",
                shrink: "1",
                overflow: "hidden"
            },
            ProcessMObile: {
                padding: "0px",
                width: "100%",
                height: "100%"
            },
            "Everyone Agrees.\u00A0": {
                height: "unset",
                shrink: "1"
            },
            "You\u2019re about to experience an innovative, new roadmap so you discover the job you\u2019ll treasure.": {
                shrink: "1"
            },
            "This Is Job Search Done Right.": {
                shrink: "1"
            },
            "Frame 1160464114": {
                gap: "10px"
            },
            "Effortless, Rewarding, Fast": {
                shrink: "1"
            },
            "We Search - You Approve": {
                shrink: "1"
            },
            "Results That You Can Trust\u00A0": {
                shrink: "1"
            },

            Check763024709: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },

            Check763024713: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },

            Check763024717: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            }


        }
    }, []);

    const sayGoodByeMobileOverrides = useMemo(() => {
        return {
            SayGoodByeMobile: {
                width: "100%",
                height: "100%",
            },
            Image: {
                width: "unset",
                height: "unset",
                src: SayGoodbyeImage,
                objectFit: "contain",
                padding: "20px"
            },
            ProcessMObile: {
                padding: "20px"
            },
            "Say Good-Bye to the Endless Drudgery of:": {
                shrink: "1"
            },
            "You\u2019re about to experience an innovative, new roadmap so you discover the job you\u2019ll treasure.": {
                shrink: "1"
            },
            "Managing The Submission Process": {
                shrink: "1",
                basis: "0",
                grow: "1"
            },
            "Stressful Resume Sorting": {
                shrink: "1",
                basis: "0",
                grow: "1"
            },
            "Corresponding With Those Who Don\u2019t Fit": {
                basis: "0",
                grow: "1",
                shrink: "1"
            },
            Item: {
                position: "absolute",
                top: "25%",
                right: "0"
            },
            "Frame 1160464556": {
                position: "relative",
                top: "unset",
                left: "unset"
            },
            "image 18": {
                src: SayGoodbyeImage3,
                objectFit: "contain",
                width: "100%",
                height: "100%"
            },
            "image 19": {
                src: SayGoodbyeImage2,
                objectFit: "contain",
                position: "absolute",
                top: "20%",
                left: "0"
            },
        };
    }, []);

    const sayHelloMobileOverrides = useMemo(() => {
        return {
            SayHelloMobile: {
                width: "100%",
                height: "100%",

            },
            "Say Hello To:": {
                shrink: "1"
            },
            "Click - Sort - Done - SMILE!": {
                shrink: "1",
                grow: "1",
                basis: "0"
            },
            "Happier Candidates": {

            },
            "Satisfying, Long-Term Results\u00A0": {

            },
            Button: {
                width: "100%",
                style: {
                    cursor: "pointer"
                },
                onClick: (event) => {
                    window.open(`${RECRUITER_APP}`, "_blank");
                }
            },
            label: {
                shrink: "1",
            },
            Check763325134: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },

            Check763325139: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            Check763325144: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            }

        };
    }, []);

    const noCrystalBallMobileOverrides = useMemo(() => {
        return {
            NoCrystalBallMobile: {
                width: "100%",
                height: "100%",
            },
            "No Crystal Ball Required.\u00A0": {
                shrink: "1"
            },
            "The Info you Need.\u2028No Resume To Read.\u00A0": {
                shrink: "1"
            },
            "Only Top Qualifiers For Your Company\u00A0": {
                shrink: "1",
                grow: "1",
                basis: "0"
            },
            "Protect Your Corporate Culture\u00A0": {

            },
            "Line 2": {
                width: "unset"
            },
            "Strong Candidates Create Strong Teams\u00A0": {

            },
            "Line 4": {
                width: "unset"
            },
            "Contributors - not Inhibitors.\u00A0": {

            },
            Button: {
                width: "100%",
                style: {
                    cursor: "pointer"
                },
                onClick: (event) => {
                    window.open(`${RECRUITER_APP}`, "_blank");
                }
            },
            label: {
                shrink: "1",
                children: "Start Hiring with Ikimy"
            },

            Check763525155: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            Check763525159: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            Check763525163: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            },
            Check763525178: {
                children: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M11.4419 19.553L6.22656 14.3364L7.9646 12.5984L11.4419 16.0745L18.3941 9.12109L20.1334 10.8604L11.4419 19.5506V19.553Z" fill="#3D4D67" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0800781 14.2513C0.0800781 6.78411 6.13372 0.730469 13.6009 0.730469C21.0681 0.730469 27.1217 6.78411 27.1217 14.2513C27.1217 21.7185 21.0681 27.7721 13.6009 27.7721C6.13372 27.7721 0.0800781 21.7185 0.0800781 14.2513ZM13.6009 25.3138C12.1482 25.3138 10.7096 25.0277 9.36748 24.4717C8.02531 23.9158 6.80579 23.1009 5.77854 22.0737C4.75129 21.0464 3.93644 19.8269 3.38049 18.4847C2.82455 17.1426 2.53841 15.7041 2.53841 14.2513C2.53841 12.7986 2.82455 11.36 3.38049 10.0179C3.93644 8.6757 4.75129 7.45618 5.77854 6.42893C6.80579 5.40168 8.02531 4.58683 9.36748 4.03088C10.7096 3.47494 12.1482 3.1888 13.6009 3.1888C16.5349 3.1888 19.3487 4.35431 21.4233 6.42893C23.4979 8.50355 24.6634 11.3173 24.6634 14.2513C24.6634 17.1853 23.4979 19.999 21.4233 22.0737C19.3487 24.1483 16.5349 25.3138 13.6009 25.3138Z" fill="#3D4D67" />
                    </svg>
                )
            }
        };
    }, []);

    const truthFromMobileOverrides = useMemo(() => {
        return {
            TruthFromMobile: {
                width: "100%",
                height: "100%"
            },
            "Truth From Those Who Know\u00A0": {
                shrink: "1"
            },
            "By using Ikimy's standardized recruitment process, employers can improve their ability to select candidates who are well-suited for their roles by\u00A045%* or more - enhancing overall organizational performance and employee retention. (International Journal of Social Science And Human Research, 2023)": {
                shrink: "1",
                children: (
                    <>
                        <span
                            style={{
                            }}
                            children="By using Ikimy's standardized recruitment process, employers can improve their ability to select candidates who are well-suited for their roles by 45%* or more - enhancing overall organizational performance and employee retention."
                        >
                        </span>
                        <br></br>
                        <br></br>
                        <span
                            style={{

                                fontStyle: "italic",
                                fontWeight: "300",

                            }}
                            children="(International Journal of Social Science And Human Research, 2023)"
                        >
                        </span>
                    </>
                )
            },

        }
    }, []);

    return (
        <>
            <HeroRecruiterMobile overrides={heroRecruiterMobileOverrides}></HeroRecruiterMobile>
            <EveryoneAgreesMobile overrides={everyoneAgreesMobileOverrides}></EveryoneAgreesMobile>
            <SayGoodByeMobile overrides={sayGoodByeMobileOverrides}></SayGoodByeMobile>
            <SayHelloMobile overrides={sayHelloMobileOverrides}></SayHelloMobile>
            <Flex
                width="100%"
                height="100%"
                padding="20px"
                position="relative"
                justifyContent="center"
            >
                <Image
                    src={NoCrystalBallImage}
                    objectFit="contain"
                ></Image>
                <Image
                    width="194px"
                    height="167.5px"
                    aspectRatio="194.00/167.50"
                    src={NoCrystalBallImage2Mobile}
                    objectFit="contain"
                    position="absolute"
                    left="0"
                    top="55%"
                ></Image>
            </Flex>
            <NoCrystalBallMobile overrides={noCrystalBallMobileOverrides}></NoCrystalBallMobile>
            <TruthFromMobile overrides={truthFromMobileOverrides}></TruthFromMobile>
            <Flex
                direction="column"
                width="100%"
                justifyContent="flex-start"
                alignItems="center"
                overflow="hidden"
                position="relative"
                borderRadius="8px"
                backgroundColor="rgba(251,245,231,1)"
            >
                <Flex
                    width="100%"
                    display="flex"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    children={(
                        <Image
                            src={PartnerWithUsImageMobile}

                            width="100%"
                            height="80%"
                            objectFit="cover"
                            objectPosition="50% 50%"
                        ></Image>
                    )}
                ></Flex>
                <Flex
                    gap="32px"
                    direction="column"
                    width="100%"
                    height="unset"
                    justifyContent="flex-start"
                    alignItems="center"
                    shrink="1"
                    grow="1"
                    basis="0"
                    position="relative"
                    padding="40px 20px"
                >
                    <Text
                        fontFamily="Inter"
                        fontSize="32px"
                        fontWeight="400"
                        color="rgba(0,0,0,1)"
                        lineHeight="38.727272033691406px"
                        textAlign="center"
                        display="block"
                        direction="column"
                        justifyContent="unset"
                        width="unset"
                        height="unset"
                        gap="unset"
                        alignItems="unset"
                        shrink="1"
                        alignSelf="stretch"
                        position="relative"
                        padding="0px 0px 0px 0px"
                        whiteSpace="pre-wrap"
                        children={(
                            <>
                                <span
                                    style={{
                                        color: "#0B141F",
                                        fontFamily: "Inter",
                                        fontSize: "40px",
                                        fontStyle: "normal",
                                        fontWeight: "700",
                                        lineHeight: "normal"
                                    }}
                                >
                                    Partner with Us
                                </span>
                                <br></br>
                                <span
                                    style={{
                                        color: "#000",
                                        fontFamily: "Inter",
                                        fontSize: "20px",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        lineHeight: "150%"
                                    }}

                                >
                                    Make The Smart Move Today.
                                </span>
                                <br></br>
                                <span
                                    style={{
                                        color: "#000",
                                        fontFamily: "Inter",
                                        fontSize: "20px",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        lineHeight: "150%"
                                    }}

                                >
                                    Discover Why ikimy Works.
                                </span>
                            </>

                        )}

                    ></Text>
                    <Flex
                        gap="0"
                        direction="row"
                        width="unset"
                        height="unset"
                        justifyContent="center"
                        alignItems="center"
                        shrink="0"
                        position="relative"
                        borderRadius="4px"
                        padding="16px 24px 16px 24px"
                        backgroundColor="rgba(204,164,59,1)"
                        style={{
                            cursor: "pointer"
                        }}
                        onClick={(event) => {
                            window.open(`${RHEALIZE_WEBSITE}`, "_blank");
                        }}
                    >
                        <Text
                            fontFamily="Inter"
                            fontSize="16px"
                            fontWeight="700"
                            color="rgba(255,255,255,1)"
                            lineHeight="24px"
                            textAlign="left"
                            display="block"
                            direction="column"
                            justifyContent="unset"
                            width="unset"
                            height="unset"
                            gap="unset"
                            alignItems="unset"
                            shrink="0"
                            position="relative"
                            padding="0px 0px 0px 0px"
                            whiteSpace="pre-wrap"
                            children="Start Hiring with Rhealize"
                        ></Text>
                    </Flex>
                </Flex>
            </Flex>
        </>
    )
};

export default MobileRecruiter;